import { useDisclosure } from "@mantine/hooks";
import type { HTMLAttributes, ReactNode, Ref } from "react";
import { forwardRef } from "react";

import { Popover } from "metabase/ui";

import { ColorPickerContent } from "./ColorPickerContent";
import { ColorPickerTrigger } from "./ColorPickerTrigger";

export type ColorPickerAttributes = Omit<
  HTMLAttributes<HTMLDivElement>,
  "onChange"
>;

export interface ColorPickerProps extends ColorPickerAttributes {
  value: string;
  label?: ReactNode;
  placeholder?: string;
  isAuto?: boolean;
  onChange?: (color?: string) => void;
}

export const ColorPicker = forwardRef(function ColorPicker(
  { value, label, placeholder, isAuto, onChange, ...props }: ColorPickerProps,
  ref: Ref<HTMLDivElement>,
) {
  const [opened, { open, close }] = useDisclosure(false);

  return (
    <Popover opened={opened} onDismiss={close} position="bottom-start">
      <ColorPickerTrigger
        {...props}
        ref={ref}
        value={value}
        label={label}
        placeholder={placeholder}
        isAuto={isAuto}
        onClick={open}
        onChange={onChange}
      />
      <Popover.Dropdown>
        <ColorPickerContent value={value} label={label} onChange={onChange} />
      </Popover.Dropdown>
    </Popover>
  );
});
